<template>
  <v-container>
    <v-row>
      <v-col>
        <v-text-field
          solo
          clearable
          label="Search"
          append-icon="mdi-magnify"
          v-model="search_term"
          @input="filter"
        ></v-text-field>
      </v-col>
      <v-col>
        <v-dialog
          width="500"
          v-model="dialog"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-btn elevation="2" v-bind="attrs" v-on="on"><v-icon>mdi-plus</v-icon></v-btn>
          </template>

          <License edit=true ref="newLicense" v-bind:license="{}" v-bind:all_applications="all_applications" v-bind:license_types="license_types" @OnSubmit="license => submit('POST', license)"/>
        </v-dialog>
      </v-col>
      <v-col>
        <v-btn elevation="2" @click="fetch_data"><v-icon>mdi-refresh</v-icon></v-btn>
      </v-col>
    </v-row>
    <v-card
    class="mx-auto"
    v-for="(license, i) in filtered_licenses"
    v-bind:key="i"
    >
    <v-card-title>{{ filtered_licenses[i].license_id }}</v-card-title>
    <v-card-subtitle class="text-left">{{ filtered_licenses[i].company }}</v-card-subtitle>
    <v-card-text class="text-left">{{ filtered_licenses[i].description }}</v-card-text>
    <v-card-text class="text-left">Expiry Date: {{ filtered_licenses[i].end }}</v-card-text>
    <v-card-actions>
      <v-dialog
      >
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            dark
            v-bind="attrs"
            v-on="on"
          >
            View
          </v-btn>
        </template>
        <License readonly=true v-bind:license="filtered_licenses[i]" v-bind:all_applications="all_applications" v-bind:license_types="license_types"/>
      </v-dialog>
      <v-btn @click="() => sign(filtered_licenses[i].license_id)" v-if="['ONPREMISE_EXPERT', 'ONPREMISE_EXPERT_PLUS'].includes(filtered_licenses[i].type)">Sign</v-btn>
      <v-dialog
      >
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            v-bind="attrs"
            v-on="on"
          >
            <v-icon>mdi-pencil</v-icon>
          </v-btn>
        </template>
        <License edit="true" v-bind:license="filtered_licenses[i]" v-bind:all_applications="all_applications" v-bind:license_types="license_types" @OnSubmit="license => submit('PATCH', license)"/>
      </v-dialog>
    </v-card-actions>
    </v-card>
  </v-container>
</template>

<script>
// @ is an alias to /src
import { getInstance } from "@/auth";
import License from "@/components/License"
export default {
  name: 'Licenses',
  components: {
    License
  },
  data() {
    return {
      licenses: [],
      api: "http://localhost:8000",
      search_term: '',
      filtered_licenses: [],
      license_types: ['ONPREMISE_EXPERT', 'EXPERT', 'LITE'],
      all_applications: [],
      dialog: false,
      auth0_instance: null
    }
  },
  async created() {
      this.auth0_instance = await getInstance();
      if (this.auth0_instance.loading) {
        this.auth0_instance.$watch("loading", async loading => {
          if (!loading && this.auth0_instance.isAuthenticated) {
            this.fetch_data();
           }

        });
      } else {
        this.fetch_data();
      }
  },
  methods: {
    filter(term) {
      term = term || '';
      term = term.toLowerCase();
      this.filtered_licenses = this.licenses.filter(license => license.license_id.toLowerCase().includes(term))
    },
    async fetch_data() {
      var token = await this.auth0_instance.getTokenSilently();
      var response = await fetch(`${this.$license_api}/license`, {
          headers: {
            'Authorization': `Bearer ${token}`
          },
       })
       var data = await response.json()
       this.licenses = data["licenses"];
       this.filtered_licenses = data["licenses"];
       response = await fetch(`${this.$license_api}/application`, {
          headers: {
            'Authorization': `Bearer ${token}`
          },
       })
       data = await response.json();
       this.all_applications = data["apps"].map(app => app.name);
    },
    async sign(license_id) {
      const token = await this.$auth.getTokenSilently();
      const response = await fetch(`${this.$license_api}/sign/team/${license_id}`, {
        method: 'POST',
        mode: 'cors',
        cache: 'no-cache',
        credentials: 'same-origin',
        redirect: 'follow', // manual, *follow, error
        referrerPolicy: 'no-referrer',
        headers: {
          'Authorization': `Bearer ${token}`
        },
      });
      if (response.ok !== true) {
        alert(await response.text())
      } else {
        var license = await response.json();
        var json = JSON.stringify(license, null, 4);
        var blob = new Blob([json], {type: "application/json"});
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.style.display = 'none';
        a.href = url;
        a.download = 'license.json';
        document.body.appendChild(a);
        a.click();
        window.URL.revokeObjectURL(url);

      }
    },
    async submit(method, license) {
      const instance = await getInstance();
      const token = await instance.getTokenSilently();
      const response = await fetch(`${this.$license_api}/license`, {
          method: method,
          mode: 'cors',
          cache: 'no-cache',
          credentials: 'same-origin',
          referrerPolicy: 'no-referrer',
          headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`
          },
          body: JSON.stringify(license)
        });
      if (response.ok !== true) {
        alert(await response.text())
      } else {
        this.app_name = null
        this.is_floating = false
        this.url = null
        this.dialog = false
        alert("success")
        this.$refs.newLicense.reset()
      }

    }
  },
  computed: {

  }
}
</script>
